import { Ad } from './ad';

export class Serie {
    public id: number|null = null;
    public name: string|null = null;
    public title: string|null = null;
    public ads: Ad[] = [];
}

